import { useToastContext } from '../components/ToastProvider';

/**
 * useToast hook
 * Returns the showToast function for displaying toast notifications.
 * Usage: const { showToast } = useToast();
 */
export const useToast = () => {
  const { showToast } = useToastContext();
  return { showToast };
}; 